// Client helper for the server-side /api/v1/notify/email endpoint.
// Fire-and-forget: callers should NOT await in a way that blocks the UI,
// and email failures must never break the user-facing flow that triggered them.

import SessionManager from './SessionManager';
import ErrorLoggingService from './ErrorLoggingService';
import { baseurl } from '../util/config';

const ENDPOINT = baseurl + 'api/v1/notify/email';

export async function sendNotificationEmail({ type, to, payload }) {
  if (!to) return { ok: false, error: 'no recipient' };

  try {
    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${SessionManager.getAccessToken()}`,
      },
      body: JSON.stringify({ type, to, payload: payload || {} }),
    });

    if (!res.ok) {
      ErrorLoggingService.log(
        ErrorLoggingService.LOG_LEVELS.WARN,
        ErrorLoggingService.ERROR_CATEGORIES.NETWORK,
        'notification.send.failed',
        null,
        { type, status: res.status }
      );
      return { ok: false, error: `HTTP ${res.status}` };
    }

    const data = await res.json().catch(() => ({}));
    return { ok: true, id: data.id };
  } catch (err) {
    ErrorLoggingService.log(
      ErrorLoggingService.LOG_LEVELS.WARN,
      ErrorLoggingService.ERROR_CATEGORIES.NETWORK,
      'notification.send.failed',
      err,
      { type }
    );
    return { ok: false, error: err.message };
  }
}
